import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const error = searchParams.get('error');

  const handleOidcLogin = () => {
    setIsLoading(true);
    const apiUrl = import.meta.env.VITE_API_URL;
    window.location.href = `${apiUrl}/api/v1/auth/oidc/login`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <svg className="h-10 w-10" viewBox="0 0 100 100" fill="currentColor">
              <path d="M30 70V30h10l10 25 10-25h10v40h-8V45l-8 20h-8l-8-20v25z" />
            </svg>
          </div>
          <CardTitle className="text-2xl">Velkommen til Arkitekt</CardTitle>
          <CardDescription>Logg inn for å fortsette</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <div className="p-3 text-sm text-destructive bg-destructive/10 rounded-md border border-destructive/20">
              {error === 'authentication_failed' ? 'Innlogging feilet. Prøv igjen.' : error}
            </div>
          )}

          <Button
            className="w-full"
            onClick={handleOidcLogin}
            disabled={isLoading}
          >
            {isLoading ? (
              'Omdirigerer...'
            ) : (
              <>
                <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                </svg>
                Logg inn med Omni-Tek SSO
              </>
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
